(function () {
  function init(root) {
    if (root.dataset.lpInit) return;
    root.dataset.lpInit = '1';
    var dataEl = root.querySelector('[data-lp-json]');
    var data = dataEl ? JSON.parse(dataEl.textContent) : null;
    var track = root.querySelector('[data-lp-track]');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-lp-thumb]'));
    var prev = root.querySelector('.lp-arrow--prev');
    var next = root.querySelector('.lp-arrow--next');

    function current() {
      if (!track || !track.clientWidth) return 0;
      return Math.round(track.scrollLeft / track.clientWidth);
    }
    function goTo(i, smooth) {
      if (!track) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    function sync() {
      var i = current();
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      if (thumbs[i] && thumbs[i].parentNode) {
        var p = thumbs[i].parentNode, t = thumbs[i];
        if (t.offsetLeft < p.scrollLeft || t.offsetLeft + t.offsetWidth > p.scrollLeft + p.clientWidth) p.scrollTo({ left: t.offsetLeft - 16, behavior: 'smooth' });
      }
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
    }
    if (track) {
      var timer;
      track.addEventListener('scroll', function () { clearTimeout(timer); timer = setTimeout(sync, 60); }, { passive: true });
      sync();
    }
    if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
    if (next) next.addEventListener('click', function () { goTo(current() + 1); });
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { goTo(n); }); });

    if (!data) return;
    var selected = data.selected.slice();
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-lp-option]'));
    var idInput = root.querySelector('product-form input[name="id"]');
    var atc = root.querySelector('.lp-atc');
    var atcText = atc ? atc.querySelector('span') : null;

    function findVariant(opts) {
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) if (v.options[j] !== opts[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }
    function availability() {
      groups.forEach(function (g) {
        var idx = +g.dataset.lpOption;
        g.querySelectorAll('[data-value]').forEach(function (b) {
          var test = selected.slice(); test[idx] = b.dataset.value;
          var v = findVariant(test);
          b.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }
    function update() {
      var v = findVariant(selected);
      groups.forEach(function (g) {
        var idx = +g.dataset.lpOption;
        g.querySelectorAll('[data-value]').forEach(function (b) { b.classList.toggle('is-active', b.dataset.value === selected[idx]); });
        var lab = g.querySelector('[data-lp-selected]');
        if (lab) { var ab = g.querySelector('.is-active[data-value]'); lab.textContent = (ab && ab.getAttribute('data-label')) || selected[idx]; }
      });
      availability();
      if (!v) {
        if (atc) atc.setAttribute('disabled', 'disabled');
        if (atcText) atcText.textContent = data.t.unavailable;
        return;
      }
      if (idInput) idInput.value = v.id;
      var price = root.querySelector('[data-lp-price]');
      if (price && v.html) price.innerHTML = v.html;
      var label = root.querySelector('[data-lp-label]');
      if (label) { label.textContent = v.pct ? v.pct + data.t.off : ''; label.style.display = v.pct ? '' : 'none'; }
      if (atc) {
        if (v.available) { atc.removeAttribute('disabled'); if (atcText) atcText.textContent = data.t.add; }
        else { atc.setAttribute('disabled', 'disabled'); if (atcText) atcText.textContent = data.t.soldout; }
      }
      if (v.media) {
        for (var i = 0; i < slides.length; i++) if (slides[i].dataset.mediaId == v.media) { goTo(i); break; }
      }
      try { history.replaceState(null, '', location.pathname + '?variant=' + v.id); } catch (e) {}
    }
    groups.forEach(function (g) {
      var idx = +g.dataset.lpOption;
      g.addEventListener('click', function (e) {
        var b = e.target.closest('[data-value]');
        if (!b) return;
        e.preventDefault();
        selected[idx] = b.dataset.value;
        update();
      });
    });
    availability();
  }
  function boot() { document.querySelectorAll('[data-lp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
